.header {
  font-weight: bold !important;
}

.content {
  text-align: right;
}
